import * as authHelper from './../../../../modules/auth/core/AuthHelpers'

import { AsideMenuHyperLink } from "../../../../layout/components/aside/AsideMenuItem"
import { IPageAction } from "../../../base/models"
import { Property } from '../../../base/types'
import { getBaseUrl } from '../url-helper'
import { useGetProperties } from '../../../base/hooks'

export const AsideMenuPortalLink = ({ action, hasBullet, className }: {
    action: IPageAction,
    hasBullet: boolean
    className?: string
}) => {
    const { token } = authHelper.getAuth() || {}
    const { properties } = useGetProperties({ bindings: action.bindings });
    const pageUrl: string | undefined = properties[Property.Url];
    const target: string | undefined = properties[Property.Target];

    if (!token || !pageUrl)
        return <></>

    const base64Token = btoa(token);

    return (
        <AsideMenuHyperLink
            hasBullet={hasBullet}
            className={className}
            target={target || undefined}
            to={`${getBaseUrl(pageUrl)}/auth/token-auth(${encodeURIComponent(base64Token)})`}
            materialIcon={action.icon}
            title={action.name}
            fontIcon='bi-app-indicator'
        />)
}